(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const toggle = document.querySelector('[data-nav-toggle]');
    const nav = document.getElementById('SiteNav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function () {
    var fields = document.querySelector('.password-page__fields');
    var form = document.querySelector('.password-page__form');
    if (!fields || !form) return;

    var key = 'yareta-waitlist';

    if (fields.querySelector('.password-page__error')) {
      sessionStorage.removeItem(key);
      return;
    }

    if (
      /contact_posted=true/.test(location.search) ||
      (sessionStorage.getItem(key) && location.hash === '#contact_form')
    ) {
      sessionStorage.removeItem(key);
      fields.classList.add('is-thanks');
      return;
    }

    form.addEventListener('submit', function () {
      sessionStorage.setItem(key, '1');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-product-root]');
    if (!root) return;

    const dataEl = document.querySelector('[data-product-variants]');
    const idInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-product-price]');
    const button = root.querySelector('[data-add-button]');
    const inputs = root.querySelectorAll('[data-option-input]');
    if (!dataEl || !idInput || !button || inputs.length === 0) return;

    const variants = JSON.parse(dataEl.textContent);

    const update = () => {
      const selected = [];
      root.querySelectorAll('[data-option-position]').forEach((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        selected[Number(fieldset.dataset.optionPosition) - 1] = checked ? checked.value : null;
      });

      const variant = variants.find((v) => v.options.every((value, index) => value === selected[index]));

      if (!variant) {
        button.disabled = true;
        button.textContent = button.dataset.labelUnavailable;
        return;
      }

      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      button.disabled = !variant.available;
      button.textContent = variant.available ? button.dataset.labelAdd : button.dataset.labelSoldOut;
    };

    inputs.forEach((input) => input.addEventListener('change', update));
  })();

  } catch(e) { console.error(e); }
})();
})();
